import { Grid, Text } from '@chakra-ui/react'

import { IncidentCreatorType } from '@/features/incident-drawer'
import { creatorRoleName, formatFullName } from '@/utils/formats'

interface ButtonTagIProps {
  description: string
  creator?: IncidentCreatorType
  manualIncidentCategoryName?: string
}

export const ManualIncidentDescription = ({
  description,
  creator,
  manualIncidentCategoryName,
}: ButtonTagIProps) => {
  return (
    <>
      <span>{description}</span>
      {(creator || manualIncidentCategoryName) && (
        <Grid gap='10px 0px' mb='20px' mt='20px' templateColumns='175px 1fr'>
          {creator && (
            <>
              <Text fontSize='14px' fontWeight={700}>
                Reporting Person
              </Text>
              <Text fontSize='14px' fontWeight={500}>
                {`${creatorRoleName(creator.roleName)} ${formatFullName(
                  creator
                )}`}
              </Text>
            </>
          )}
          {manualIncidentCategoryName && (
            <>
              <Text fontSize='14px' fontWeight={700}>
                Incident Category
              </Text>
              <Text fontSize='14px' fontWeight={500}>
                {manualIncidentCategoryName}
              </Text>
            </>
          )}
        </Grid>
      )}
    </>
  )
}
